import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import RadioGroup from 'components/core/RadioGroup';
// Custom
import { DisabledContext } from 'components/misc/Contexts';

const PeriodFilter = ({
  labelId, periods, value, onChange,
}) => (
  <div className="d-flex align-items-center w-100">
    <div className="pr-3 hidden-sm-down">
      <LocalizedMessage id={labelId} />
    </div>
    <DisabledContext.Consumer>
      {(disabled) => (
        <RadioGroup
          disabled={disabled}
          value={value}
          items={
            _map(periods, (period) => (
              {
                key: period.value,
                value: period.value,
                label: <LocalizedMessage id={period.labelId} />,
              }
            ))
          }
          row
          onChange={onChange}
        />
      )}
    </DisabledContext.Consumer>
  </div>
);

PeriodFilter.propTypes = {
  labelId: PropTypes.string.isRequired,
  periods: PropTypes.arrayOf(PropTypes.shape({
    labelId: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

module.exports = PeriodFilter;



// WEBPACK FOOTER //
// ./components/filters/PeriodFilter.js